<script lang="ts">
    import { page } from '$app/stores';
    import OverlayManager from './OverlayManager.svelte';

    $: isShellShown = $page.route.id?.includes('(content)');
    $: rgHeaderShown = $page.data.market.hasRgHeader && isShellShown;
</script>

<div
    class="
        contents
        [--header-height:calc(var(--nav-height)+var(--rg-height))]
        [--nav-height:64px]
        tablet:[--bottom-bar-height:0px]
        desktop-l:[--bottom-bar-height:0px]
        desktop-l:[--nav-height:80px]
        {isShellShown ? '[--bottom-bar-height:64px]' : '[--bottom-bar-height:0px]'}
        {rgHeaderShown ? '[--rg-height:theme(spacing.lg)]' : '[--rg-height:0px]'}
    "
>
    <OverlayManager>
        <slot />
    </OverlayManager>
</div>
